module.exports = {
  ModuleName: 'Tên mô-đun',
  OperationChangeTime: 'Thời gian thay đổi thao tác',
  Operator: 'Người thao tác',
  To: 'đến',
  Close: 'Đóng',
  SerialNumber: 'Số serial',
  OperationTime: 'Thời gian thao tác',
  QueryScheme: 'Phương án truy vấn',
  QuickSearchBusinessCode: 'Tìm kiếm nhanh: Số nghiệp vụ',
  YouDidntOpen: 'Bạn chưa mở',
  FinancialAudit: 'Kiểm tra tài chính',
  ModulePermissions: 'Quyền của mô-đun',
  IfTheDataLoadingYears: 'Nếu phạm vi ngày được chọn lớn hơn 2 năm sẽ ảnh hưởng đến tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  StartDate: 'Ngày bắt đầu',
  EndDate: 'Ngày kết thúc',
  ContentDescription: 'Mô tả nội dung',
  Name: 'Tên'
}
